import PromotionDetailContainer from './PromotionDetailContainer';
export default PromotionDetailContainer;
